module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/i5YUxL/tc-custom/9781398486423.jpg?1718251156326",
      "alt": "This image is the cover for the book The Life and Times of a Country Lad"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("The Life and Times of a Country Lad\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("This is the life story of Clive Towle, born in 1939 a few months before the beginning of WW2. A shy lad who grew up to be adventurous and creative and admits to still being a little shy on occasions. Clive has experienced many things in life, mostly good, but some not so good. His story relates to many different aspects of life that, suggested by some, few could equal. In his own words, “I've done so many things in my life, quite a few people have said, 'You should write a book', so I did.” He covers the war, school, farming, army, various jobs, self employed, two marriages and old age. A fairly compelling read to say the least.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Clive Towle\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Author, Clive Towle, born in 1939 a few months before the beginning of WW2 shares his life-time memories with the readers. This is a full and very lively story covering many good, and not so good aspects of life. But with honesty and belief in himself.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0